var resizeTimer;
const footer = $('.footer');
const mainwrapper = $(".l-mainwrapper");

$(window).on("resize", function(e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        var footerH = footer.outerHeight();
        mainwrapper.css('margin-bottom', footerH);
    }, 250);
}).trigger('resize');
